// @flow

import { observer } from "mobx-react";
import React from "react";
import type { VideoSources } from "timelinely-player/TimelinelyPlayer";

import "./HtmlVideo.scss";

type Props = {
    videoUrls: VideoSources
};

@observer
export default class HtmlVideo extends React.Component<Props> {
    render() {
        return (
            <video controls className="HtmlVideo">
                {Object.keys(this.props.videoUrls).map(mimeType => {
                    return (
                        <source
                            src={this.props.videoUrls[mimeType]}
                            type={mimeType}
                            key={mimeType}
                        />
                    );
                })}
                Your browser does not support the video tag.
            </video>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/HtmlVideo/HtmlVideo.js